//@ts-nocheck
import Skeleton from '@mui/material/Skeleton';
import { Box } from '@mui/material';
import * as PropTypes from 'prop-types';
import '../ManageBooking.css';

const ManageBookingSkeleton = ({ id, ...rest }) => {
  const plansElementsLength = 2;
  const headerElementsLength = 5;

  return (
    <Box id={id} className='booking-panel-container' {...rest}>
      <Box sx={{ height: '24px', position: 'relative' }}>
        <Skeleton
          width={120}
          height={41}
          sx={{
            padding: '0',
            margin: '0',
            position: 'absolute',
            top: '-9px',
            borderRadius: '0'
          }}
        />
      </Box>
      <Box
        className='booking-panel__main-header__manage-booking'
        sx={{ marginTop: '24px', height: '46px' }}
      >
        <Skeleton
          variant='text'
          sx={{
            fontSize: '32px',
            width: '254px',
            height: '65px',
            marginTop: '-4px'
          }}
        />
        <Skeleton sx={{ width: '181px', height: '70px', marginTop: '-4px' }} />
      </Box>
      <Box
        className='booking-panel-header-info'
        sx={{ marginTop: '40px', height: '86px' }}
      >
        {Array.from({ length: headerElementsLength }).map((_, index) => (
          <Box
            key={`menu-skeleton-${index}`}
            className='booking-panel-header-info-item'
          >
            <Skeleton
              variant='rectangular'
              width={'120px'}
              height={22}
              sx={{ marginBottom: '8px' }}
            />
            <Skeleton variant='rectangular' width={'120px'} height={20} />
          </Box>
        ))}
      </Box>
      <Box
        className='booking-panel__pricing-plans'
        sx={{ minHeight: '403px', height: 'auto' }}
      >
        {Array.from({ length: plansElementsLength }).map((_, index) => (
          <Box key={`menu-skeleton-${index}`}>
            <Box
              className='booking-panel__pricing-plan'
              key={`menu-skeleton-${index}`}
            >
              <Skeleton
                variant='text'
                sx={{ fontSize: '25px', width: '140px', height: '40px' }}
              />
              <Skeleton sx={{ width: '307px', height: '60px' }} />
              <Box className='booking-panel__pricing-plan__passengers'>
                <Skeleton
                  variant='text'
                  sx={{ fontSize: '20px', width: '190px', height: '35px' }}
                />
                <Skeleton
                  variant='text'
                  sx={{ fontSize: '20px', width: '190px', height: '35px' }}
                />
                <Skeleton
                  variant='text'
                  sx={{ fontSize: '20px', width: '190px', height: '35px' }}
                />
              </Box>
            </Box>
            {index < plansElementsLength - 1 && (
              <Box className='booking-panel__pricing-plan__passenger__divider' />
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

ManageBookingSkeleton.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ManageBookingSkeleton;
